<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M2.249,23.888c-0.601,0-1.166-0.235-1.591-0.659C0.234,22.804,0,22.239,0,21.638c0-0.634,0.449-1.189,1.069-1.321
		c0.468-0.101,0.863-0.425,1.056-0.866c0.16-0.367,0.168-0.774,0.021-1.148s-0.429-0.668-0.796-0.828C0.53,17.117,0,16.308,0,15.413
		v-4.062c0-0.013,0.001-0.026,0.002-0.04c0.003-0.065,0.017-0.138,0.042-0.209c0.002-0.007,0.011-0.031,0.014-0.037
		c0.029-0.07,0.069-0.137,0.119-0.196c0.006-0.007,0.021-0.024,0.027-0.03c0.014-0.017,0.031-0.035,0.05-0.051l11.519-10.12
		c0.412-0.365,0.944-0.567,1.498-0.567c0.061,0,0.123,0.003,0.184,0.008c5.141,0.473,8.57,3.073,10.486,7.949
		c0.001,0.002,0.009,0.022,0.01,0.024c0.007,0.019,0.014,0.041,0.019,0.064c0.005,0.016,0.012,0.039,0.016,0.063
		c0.006,0.03,0.01,0.064,0.011,0.099C24,8.326,24,8.333,24,8.351v10.687c0,1.122-0.838,2.081-1.95,2.23L2.549,23.869
		C2.449,23.882,2.348,23.888,2.249,23.888C2.25,23.888,2.25,23.888,2.249,23.888z M1.509,21.754
		c0.024,0.156,0.097,0.301,0.211,0.414c0.141,0.142,0.331,0.219,0.533,0.219c0.033,0,0.067-0.002,0.1-0.006l19.498-2.6
		c0.37-0.05,0.649-0.369,0.649-0.743v-9.83l-21,2.8v3.405c0,0.298,0.177,0.568,0.45,0.688c1.516,0.662,2.212,2.435,1.549,3.952
		C3.132,20.894,2.393,21.522,1.509,21.754z M13.271,1.602c-0.184,0-0.368,0.07-0.505,0.191L3.105,10.28l19.061-2.542
		c-1.744-3.74-4.641-5.748-8.842-6.135C13.31,1.603,13.29,1.602,13.271,1.602z"/>
	<path d="M10.875,20.351c-1.447,0-2.625-1.177-2.625-2.625s1.178-2.625,2.625-2.625c1.448,0,2.625,1.177,2.625,2.625
		S12.323,20.351,10.875,20.351z M10.875,16.601c-0.62,0-1.125,0.505-1.125,1.125s0.505,1.125,1.125,1.125S12,18.346,12,17.726
		S11.495,16.601,10.875,16.601z"/>
	<path d="M18.375,15.851c-1.448,0-2.625-1.177-2.625-2.625s1.177-2.625,2.625-2.625S21,11.779,21,13.226
		S19.823,15.851,18.375,15.851z M18.375,12.101c-0.62,0-1.125,0.505-1.125,1.125s0.505,1.125,1.125,1.125s1.125-0.505,1.125-1.125
		S18.995,12.101,18.375,12.101z"/>
	<path d="M6.375,15.1c-0.619,0-1.123-0.503-1.125-1.121c0-0.598,0.466-1.092,1.061-1.126c0.005-0.001,0.034-0.003,0.064-0.003
		c0.62,0,1.125,0.505,1.125,1.125S6.995,15.1,6.375,15.1z"/>
	<circle cx="16.875" cy="18.475" r="1.125"/>
	<circle cx="13.125" cy="13.226" r="1.125"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'animal-products-cheese',
    },
    name: {
      type: String,
      required: false,
      default: 'AnimalProductsCheese',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>